<template>
  <div class="availability">
    <span class="availability__name">{{ name }}</span>
    <div v-if="availability.points" class="availability__points">
      <vb-icon class="availability__icon" :name="'wallet'" :color="sass('gray-900')" :size="16" />
      <span class="availability__label">{{ availability.points.label || 'Punti Fedeltà' }}:</span>
      <img
        class="availability__points-image"
        alt=""
        :src="availability.points.iconUrl || 'assets/images/common/statics/fallback_loyalty.png'"
      />
      <span class="availability__total">{{ availability.points.total }}</span>
    </div>
    <template v-else>
      <div v-if="availability.total >= 0" class="availability__credits">

        <div v-if="availability.is_known" class="d-flex align-items-center">
          <vb-icon class="availability__icon" :name="'wallet'" :color="sass('gray-900')" :size="16" />
          <span class="availability__label">Credito:</span>
          <strong class="availability__total">€ {{ availability.total }}</strong>
        </div>

        <div v-if="availability.total !== availability.details.integration && !availability.details.discount_codes">
          <span class="availability__label">Credito Welfare:</span>
          <strong class="availability__total">€ {{ availability.details.integration }}</strong>
        </div>

        <div v-if="availability.details.discount_codes" class="d-flex align-items-center">
          <vb-icon class="availability__icon" :name="'ticket'" :color="sass('gray-900')" :size="16" />
          <span class="availability__label">Codici Sconto:</span>
          <strong class="availability__total">€ {{ availability.details.discount_codes }}</strong>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'availability',

  components: {
  },

  props: {
    name: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
    }
  },

  computed: {

    availability() {
      return this.get_availability()
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .availability {
    $this: &;

    &__name {
      font-weight: $vb-font-weight-semibold;
      color: $primary;
    }

    &__icon {
      margin-right: $grid-gutter-width / 6;
    }

    &__label {
      text-transform: capitalize;

      @at-root #{$this}__points & {
        margin-right: $grid-gutter-width / 6;
      }
    }

    &__total {
      font-weight: $vb-font-weight-semibold;
    }

    &__points {
      display: flex;
      align-items: center;

      img {
        max-width: 15px;
        margin-right: $grid-gutter-width / 6;
      }
    }

    &__credits {
      display: flex;
      align-items: center;

      strong {
        margin-left: $grid-gutter-width / 6;
        font-weight: $vb-font-weight-semibold;
        color: inherit;
      }
    }
  }

</style>